// extracted by mini-css-extract-plugin
export default {"root":"Diagram_root__vdhyG","item":"Diagram_item__LDUFV","quality":"Diagram_quality__QN9n8","index":"Diagram_index__M0j1r","score":"Diagram_score__shDu8"};